// extracted by mini-css-extract-plugin
module.exports = {"c13k14ni":"c13k14ni","l1y84pl8":"l1y84pl8"};